export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";